import { useQuery } from "@tanstack/react-query";
import { client } from "../../../../api/client";

export interface Report {
  id: string;
  firstName: string;
  lastName: string;
  fileName?: string;
  createdAt: string;
  downloadedAt?: string;
}

export interface ReportsResponse {
  reports: Report[];
  page: number;
  limit: number;
  total: number;
  totalPages: number;
}

export const useReports = (page: number = 1, limit: number = 10) => {
  return useQuery<ReportsResponse>({
    queryKey: ["reports", page, limit],
    queryFn: async () => {
      const response = await client.get(`/reports?page=${page}&limit=${limit}`);
      return response.data;
    },
  });
};
